import axios from 'axios'
import {
	Message,
	Loading
} from 'element-ui'
import store from '@/store'
import router from '@/router'


// 创建axios实例
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 10000,
	headers: {
		'Content-Type': 'application/json;charset=utf-8',
		'clientid': '428a8310cd442757ae699df5d894f051',
	}
})

// 请求拦截器（添加token）
let loadingInstance = null
service.interceptors.request.use(
	config => {
		// 显示加载动画
		loadingInstance = Loading.service({
			lock: true,
			text: '加载中...',
			background: 'rgba(0,0,0,0.5)'
		})
		
		console.log('token=======')
		console.log(store.getters.token)
		
		// 从Vuex获取token
		if (store.getters.token) {
			config.headers['Authorization'] = 'Bearer ' + store.getters.token
		}
		return config
	},
	error => {
		loadingInstance.close()
		console.error('请求错误：', error)
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		loadingInstance.close()
		const res = response.data
		// 后端返回码非200则视为错误
		if (res.code !== 200) {
			Message({
				message: res.msg || '请求失败',
				type: 'error',
				duration: 3 * 1000
			})
			// 401：未登录/Token过期
			if (res.code === 401) {
				Message.warning('登录已过期，请重新登录')
				// 清除用户信息并跳转登录页
				store.dispatch('user/logout')
				router.push('/login')
			}
			return Promise.reject(new Error(res.msg || 'Error'))
		} else {
			return res
		}
	},
	error => {
		loadingInstance.close()
		console.error('响应错误：', error)
		Message({
			message: error.message || '服务器错误',
			type: 'error',
			duration: 3 * 1000
		})
		return Promise.reject(error)
	}
)

export default service